import React from 'react'
import { Grid, Link } from '@material-ui/core'
import Styles from '../components/footer.module.scss'

const facebookLink = "https://www.facebook.com/remodelmate"
const twitterLink = "https://www.twitter.com/remodelmate"
const instagramLink = "https://www.instagram.com/remodelmate"
const youtubeLink = "https://www.youtube.com/channel/UCjCj_WIhM3FVA8sr0kOAXSQ"
const remodelmateLogo = "https://remodelmate-v2-local.s3.us-east-2.amazonaws.com/branding/logos/wordmark/svg/remodelmate-black.svg"

const aboutUsUrl = "https://remodelmate.com/about"
const blogUrl = "https://blog.remodelmate.com"
const termsOfServiceUrl = "https://remodelmate.com/termsofservice"
const privacyPolicyUrl = "https://remodelmate.com/privacypolicy"
const getEstimateURl = "https://remodelmate.com/estimate/1"
const homeownersFaqUrl = "https://remodelmate.com/faq"
const contractorsLearnMoreUrl = "https://remodelmate.com/contractors"
const contractorsFaq = "https://remodelmate.com/contractors/faq"


function Footer () {
    return (
      <div className={Styles.footer}>
        <div>
          <Grid container >
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <ul>
                  <li>
                    <img
                      src={remodelmateLogo}
                      style={{ width: "10rem", height: "auto" }}
                    />
                  </li>
                  <li>
                    <p style={{ marginTop: "1rem" }}>
                      We use technology and world class customer service to make your bathroom renovation effortless.
                    </p>
                  </li>
                  <li>
                    <p style={{ marginBottom: "0" }}>
                      Want to chat with a Concierge? Text us anytime.
                    </p>
                  </li>
                  <li>
                    <Link href="tel:2026700272">
                      <p style={{ marginTop: "1rem" }}>
                        (202) 670-0272
                      </p>
                    </Link>
                  </li>
                </ul>
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <ul>
                <li>
                  <h4>
                    Company
                  </h4>
                </li>
                <li>
                  <Link href={aboutUsUrl}>
                    <p style={{ marginBottom: "0" }}>
                      About Us
                    </p>
                  </Link>
                </li>
                <li>
                  <Link href={blogUrl}>
                    <p style={{ marginTop: "0", marginBottom: "0" }}>
                      Blog
                    </p>
                  </Link>
                </li>
                <li>
                  <Link href={termsOfServiceUrl}>
                    <p style={{ marginTop: "0", marginBottom: "0" }}>
                      Terms of Service
                    </p>
                  </Link>
                </li>
                <li>
                  <Link href={privacyPolicyUrl}>
                    <p style={{ marginTop: "0", marginBottom: "0" }}>
                      Privacy Policy
                    </p>
                  </Link>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <ul>
                  <li>
                    <h4>
                      Homeowners
                    </h4>
                  </li>
                  {/* <li>
                    <Link href="/homeowners">
                      <p style={{ marginBottom: "0" }}>
                        Learn More
                      </p>
                    </Link>
                  </li> */}
                  <li>
                    <Link href={getEstimateURl}>
                      <p style={{ marginBottom: "0" }}>
                        Get an Estimate
                      </p>
                    </Link>
                  </li>
                  <li>
                    <Link href={homeownersFaqUrl}>
                      <p style={{ marginTop: "0", marginBottom: "0" }}>
                        FAQ
                      </p>
                    </Link>
                  </li>
                </ul>
            </Grid>

            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <ul>
                  <li>
                    <h4>
                      Contractors
                    </h4>
                  </li>
                  <li>
                    <Link href={contractorsLearnMoreUrl}>
                      <p style={{ marginBottom: "0" }}>
                        Learn More
                      </p>
                    </Link>
                  </li>
                  <li>
                    <Link href={contractorsFaq}>
                      <p style={{ marginTop: "0", marginBottom: "0" }}>
                        FAQ
                      </p>
                    </Link>
                  </li>
                </ul>
            </Grid>
          </Grid> 
        </div>
        <div className={Styles.footerSocialMediaIconsContainer}>
          <Link>
            <a href={facebookLink} target="blank">
              <img
                src="https://remodelmate-v2-local.s3.us-east-2.amazonaws.com/website/icons/facebook-icon.svg"
                className={Styles.footerSocialMediaIconsImage}
              />
            </a>
          </Link>
          <Link>
            <a href={twitterLink} target="blank">
              <img
                src="https://remodelmate-v2-local.s3.us-east-2.amazonaws.com/website/icons/twitter-icon.svg"
                className={Styles.footerSocialMediaIconsImage}
              />
            </a>
          </Link>
          <Link>
            <a href={instagramLink} target="blank">
              <img
                src="https://remodelmate-v2-local.s3.us-east-2.amazonaws.com/website/icons/instagram-icon.svg"
                className={Styles.footerSocialMediaIconsImage}
              />
            </a>
          </Link>
          <Link>
            <a href={youtubeLink} target="blank">
              <img
                src="https://remodelmate-v2-local.s3.us-east-2.amazonaws.com/website/icons/youtube-icon.svg"
                className={Styles.footerSocialMediaIconsImage}
              />
            </a>
          </Link>
        </div>
        <div className={Styles.footerAllRightsReservedContainer}>
          <p>
            Copyright © 2020 remodelmate, Inc. All rights reserved.
          </p>
        </div>
      </div>     
    )
}

export default Footer